import { Body1, Flex, IconFavorite, Stack, Subtitle1, ToggleButton } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/pharmacy-card/internal/HeaderGroup.tsx
const HeaderGroup = ({ title, toggleFavorite, description, additionalInfo, value, favorite = false }) => {
	return /* @__PURE__ */ jsxs(Flex, {
		justify: "space-between",
		children: [/* @__PURE__ */ jsxs(Stack, {
			gap: "xxs",
			children: [
				/* @__PURE__ */ jsx(Subtitle1, { children: title }),
				/* @__PURE__ */ jsxs(Stack, {
					gap: "xxxs",
					children: [/* @__PURE__ */ jsx(Body1, { children: description?.join(" • ") }), additionalInfo ? /* @__PURE__ */ jsx(Body1, { children: additionalInfo }) : null]
				}),
				value ? /* @__PURE__ */ jsx(Body1, { children: value }) : null
			]
		}), toggleFavorite ? /* @__PURE__ */ jsx(ToggleButton, {
			checked: favorite,
			Icon: IconFavorite,
			CheckedIcon: IconFavorite,
			iconProps: { filled: favorite },
			color: favorite ? "error" : "gray",
			disabled: false,
			toggle: toggleFavorite
		}) : null]
	});
};

//#endregion
export { HeaderGroup };